module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin flex-state-buttons"
  }, [_c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "documentEditor"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('h2', {
    staticClass: "u-d-inline-block"
  }, [_vm._v("Editing - ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimantName",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentName),
      expression: "documentName"
    }],
    staticClass: "editing",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "placeholder": "Document Name",
      "name": "documentName",
      "id": "documentName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.documentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.documentName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.documentName === ''
    }
  }, [_vm._v("\n                                The document name is required\n                            ")])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin u-padding-t-20"
  }, [_c('router-link', {
    attrs: {
      "to": this.exitRoute
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [(_vm.claimType === 'fatal_accident_dependency') ? _c('router-link', {
    staticClass: "a-button a-button--loader-button u-no-margin",
    attrs: {
      "to": {
        name: 'fatal::dependency.documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'fatal_accident_estate') ? _c('router-link', {
    staticClass: "a-button a-button--loader-button u-no-margin",
    attrs: {
      "to": {
        name: 'fatal::estate.documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'lost_years') ? _c('router-link', {
    staticClass: "a-button a-button--loader-button u-no-margin",
    attrs: {
      "to": {
        name: 'lost::documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'personal_injury') ? _c('router-link', {
    staticClass: "a-button a-button--loader-button u-no-margin",
    attrs: {
      "to": {
        name: 'personal::documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button u-margin-trbl-0-0-0-10",
    class: [_vm.savingData() ? 'a-loader--white' : '', _vm.documentName === '' ? 'disabled' : ''],
    attrs: {
      "disabled": _vm.running || _vm.documentName === ''
    },
    on: {
      "click": function($event) {
        return _vm.saveDocument()
      }
    }
  }, [_c('span', {
    class: [_vm.savingData() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Save")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--loader-button u-margin-trbl-0-0-0-10",
    class: [_vm.savingData() ? 'a-loader--white' : '', _vm.documentName === '' ? 'disabled' : ''],
    attrs: {
      "disabled": _vm.running || _vm.documentName === ''
    },
    on: {
      "click": function($event) {
        return _vm.saveAndClose()
      }
    }
  }, [_c('span', {
    class: [_vm.savingData() ? 'a-button--span-hidden' : '']
  }, [_vm._v("Save & Close")])]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), (_vm.theDocument.type === 'schedule_of_loss' || _vm.theDocument.type === 'offer_letter') ? _c('html-editor', {
    staticClass: "o-modal--html-editor",
    attrs: {
      "auto-height": false,
      "height": 750,
      "content": _vm.theDocument.html,
      "z-index": 10000
    },
    on: {
      "change": _vm.updateContent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDocument.type == 'comparison_schedule' && _vm.claimType === 'fatal_accident_dependency') ? _c('fatal-dependency-comparison-schedule', {
    attrs: {
      "index": this.$route.params.document_id,
      "document": _vm.theDocument
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDocument.type == 'comparison_schedule' && _vm.claimType === 'fatal_accident_estate') ? _c('fatal-estate-comparison-schedule', {
    attrs: {
      "index": this.$route.params.document_id,
      "document": _vm.theDocument
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDocument.type == 'comparison_schedule' && _vm.claimType === 'lost_years') ? _c('lost-comparison-schedule', {
    attrs: {
      "index": this.$route.params.document_id,
      "document": _vm.theDocument
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDocument.type == 'comparison_schedule' && _vm.claimType === 'personal_injury') ? _c('personal-comparison-schedule', {
    attrs: {
      "index": this.$route.params.document_id,
      "document": _vm.theDocument
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-generate-schedule__prompt u-d-none proto-6-a"
  }, [_c('div', {
    staticClass: "p-generate-schedule__prompt-align"
  }, [_vm._v("Are you sure you want to exit without saving?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4900a761!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/documents/DocumentEditor.vue
// module id = 1673
// module chunks = 0